function cov_2hi0g6241z() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/growth/auth/NamelessAccountContext.tsx";
  var hash = "13be1be7a30b1174eb5e8d5d3a04de18d705a3dc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/growth/auth/NamelessAccountContext.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 38
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "2": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 40,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        },
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 28
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "13be1be7a30b1174eb5e8d5d3a04de18d705a3dc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hi0g6241z = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2hi0g6241z();
import React from 'react';
export var NamelessAccountContext = (cov_2hi0g6241z().s[0]++, /*#__PURE__*/React.createContext(
// Default values for context
{
  shouldRegisterOnEmailSubmit: false,
  onPasswordFormLoad: undefined,
  onAccountUpdate: undefined,
  emailRegistrationError: ''
}));
cov_2hi0g6241z().s[1]++;
export var NamelessAccountContextProvider = function NamelessAccountContextProvider(_ref) {
  var shouldRegisterOnEmailSubmit = _ref.shouldRegisterOnEmailSubmit,
    onPasswordFormLoad = _ref.onPasswordFormLoad,
    onAccountUpdate = _ref.onAccountUpdate,
    emailRegistrationError = _ref.emailRegistrationError,
    children = _ref.children;
  cov_2hi0g6241z().f[0]++;
  cov_2hi0g6241z().s[2]++;
  return /*#__PURE__*/React.createElement(NamelessAccountContext.Provider, {
    value: {
      shouldRegisterOnEmailSubmit: shouldRegisterOnEmailSubmit,
      onPasswordFormLoad: onPasswordFormLoad,
      onAccountUpdate: onAccountUpdate,
      emailRegistrationError: emailRegistrationError
    }
  }, children);
};
//# sourceMappingURL=NamelessAccountContext.mjs.map